import { Cookie } from '@libs/common-next';

import { useOverrides } from '../../store';
import css from './actions.module.scss';
import { actions } from './config';

export const Actions = () => {
    const { setOverride } = useOverrides();

    const onClick = (type: string) => () => {
        if (type === 'reload') return window.location.reload();

        Cookie.remove('x-petm-override');
        setOverride({});
    };

    return (
        <>
            {Object.entries(actions).map(([type, action]) => (
                <div key={action.text} className={css.action}>
                    <button onClick={onClick(type)}>
                        <span>{action.icon}</span>
                        {action.text}
                    </button>
                    <span>{action.subtitle}</span>
                </div>
            ))}
        </>
    );
};
